import React, { useEffect, useState } from "react";
import MedicalService from "../../Services/MedicalService";
import dayjs from "dayjs";
import { HSdecrypt } from "../../utils/encryptPassword";

function FamilyHistory(props) {
  const [familyData, setFamliyData] = useState([]);

  useEffect(() => {
    patientFamilyHistory();
  }, [props.selectedPatient]);

  const patientFamilyHistory = () => {
    let payload = {
      patientId: props.selectedPatient,
    };
    MedicalService.HSPatientFamilyHistory(payload)
      .then((result) => {
        const decryptedData = HSdecrypt(result.data.data);
        setFamliyData(JSON.parse(decryptedData));
      })
      .catch((error) => {
        console.error(error);
      });
  };

  return (
    <div
      className="bg-white rounded-xl border border-gray-200 shadow-sm w-full"
      id="unquie-scroll"
    >
      <div className="flex justify-between items-center p-3">
        <h3 className="text-sm font-bold text-gray-700">Family History</h3>
        <div className="flex items-center gap-2 text-blue-500 font-sans font-medium underline text-xs cursor-pointer">
          {/* <HiPlusCircle className="text-primaryColor w-7 h-7"/> */}
        </div>
      </div>
      <hr />
      <div className="h-60 p-3 overflow-y-scroll flex flex-col gap-3 scrollWidth">
        {familyData.length > 0 ? (
          familyData.map((user, i) => (
            <div className="relative">
              <div className="overflow-y-scroll pr-2 scrollWidth flex flex-col gap-2">
                <div className="bg-[#F8FEFF] border border-[#9CEAFB] border-l-4 rounded-lg p-3 text-xs text-gray-700 flex flex-col gap-2">
                  <p>
                    <strong>Family History :</strong> {user?.description}
                  </p>
                  <p>
                    Onset Date : {dayjs(user.givenDate).format("YYYY-MM-DD")}
                  </p>
                </div>
              </div>
            </div>
          ))
        ) : (
          <div></div>
        )}
      </div>
    </div>
    // <div className="w-full max-w-[370px] h-[300px] sm:h-[340px] md:h-[370px] md:m-5 border rounded-lg">
    //   <div className="header h-[13%] bg-secondaryColor flex items-center justify-center rounded p-2">
    //     <h1 className="font-bold text-normal text-white mt-3">
    //       Family History
    //     </h1>
    //   </div>
    //   <div className="body h-[75%] overflow-y-auto scrollwidth bg-white border-t-2 ">
    //     {familyData.length > 0
    //       ? familyData.map((user, i) => (
    //         <div className="items-center text-sm p-2 m-3 border rounded-md">
    //           <div className="font-semibold">
    //             Family History:
    //             <span className="font-medium text-gray-500">
    //               {" "}
    //               {user?.description}
    //             </span>
    //           </div>
    //           <div className="ml-auto font-medium mt-2 flex justify-start">
    //             <h5 className="text-gray-500 font-semibold text-sm">
    //               Onset date: <span>{dayjs(user.givenDate).format('YYYY-MM-DD')}</span>
    //             </h5>
    //           </div>
    //         </div>
    //       ))
    //       : null}
    //   </div>
    //   <div className="footer h-[44px] bg-secondaryColor rounded"></div>
    // </div>
  );
}

export default FamilyHistory;
